import { Component, OnInit, Input, SimpleChanges, OnChanges, ChangeDetectorRef, ViewChild, AfterViewInit, OnDestroy, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { IonSearchbar, ModalController } from '@ionic/angular';
import { MyApp } from 'src/app/api/helper/app';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { UiHelper } from 'src/app/api/helper/ui-helper';
import { Utils } from 'src/app/api/helper/utils';
import { VertragListItem } from 'src/app/api/model/model';
import { Adresse, Auftragstyp, Vertrag } from 'src/app/api/model/swagger-model';
import { RemoteService } from 'src/app/api/remote.service';
import { StammdatenService } from 'src/app/api/stammdaten.service';
import { SystemService } from 'src/app/api/system.service';
import { VertragDetailsComponent } from '../vertrag-details/vertrag-details.component';
import { AppConfig } from 'src/app/api/helper/app.config';
import { VertragPositionenComponent } from '../vertrag-positionen/vertrag-positionen.component';

const log = new Logger("VertragSuchenComponent");

@Component({
    selector: 'app-vertrag-suchen',
    templateUrl: './vertrag-suchen.component.html',
    styleUrls: ['./vertrag-suchen.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class VertragSuchenComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
    static instance: VertragSuchenComponent;

    static vertraegeCache: Vertrag[] = null;

    @ViewChild('searchbar', { static: false }) searchbar: IonSearchbar;

    @Input() auftragstyp: Auftragstyp;

    items: VertragListItem[];

    sichtbareItems: VertragListItem[];

    isVisible = false;
    suchtext = '';
    mitPositionswahl = false;

    constructor(
        private cdr: ChangeDetectorRef,
        private systemService: SystemService,
        private stammdatenService: StammdatenService,
        private remoteService: RemoteService,
        private modalController: ModalController,) {

        VertragSuchenComponent.instance = this;
    }

    ngOnChanges(changes: SimpleChanges) {
        log?.debug('ngOnChanges');
    }

    ngOnDestroy(): void {
        log?.debug('ngOnDestroy');
        this.isVisible = false;
        MyApp.loading(false);
    }

    async ngOnInit() {
        log?.debug('ngOnInit');

        this.isVisible = true;
        this.sichtbareItems = [];

        if (!this.items) {
            // Wenn es hier keinen Delay gibt, dann gibt es komischerweise eine Exception beim Anzeigen des Loading-Indicators:
            // NG0100: Expression has changed after it was checked
            await Utils.delay(100);

            await this.ladeVertraege(false);
        }

        for (const item of this.items) {
            if (item.vertrag) {
                let adresse = item.vertrag.Abholadresse;

                // item.text = adresse.Name1;
                // item.subtext = item.vertrag.Vertragsnummer;

                // if (item.adresse.Zusatzdaten?.BestellungVorhanden === '1') {
                //     item.istFavorit = true;
                // }

                item.suchtext = item.vertrag.Abholadresse.Name1
                    + ';' + item.vertrag.Abholadresse.Name2
                    + ';' + item.vertrag.Abholadresse.Strasse
                    + ';' + item.vertrag.Abholadresse.PLZ
                    + ';' + item.vertrag.Abholadresse.Ort
                    + ';' + item.vertrag.Vertragsnummer
                    + ';' + item.vertrag.Text;

            } else {
                item.text = '???';
                item.subtext = '';
                item.suchtext = '';
            }

            item.suchtext = item.suchtext.toLowerCase();
        }

        this.refresh();
    }

    async doRefresh(event) {
        log?.debug('doRefresh');

        await UiHelper.showLoading('Verträge werden geladen...');

        event.target.complete();

        try {
            await this.ladeVertraege(true);

            this.refresh();
        } catch (err) {
            UiHelper.showError(err);
        } finally {
            UiHelper.hideLoading();
        }
    }

    async ladeVertraege(force: boolean) {
        log?.debug('ladeVertraege');

        this.items = [];
        this.cdr.detectChanges();

        let vertraege: Vertrag[] = [];

        MyApp.loading(true);

        const result = await this.remoteService.sucheVertraege({
            Suchtext: this.suchtext
        });

        if (!this.isVisible) {
            return;
        }

        MyApp.loading(false);

        if (result?.Success && result.Vertraege) {
            vertraege = result.Vertraege;
            VertragSuchenComponent.vertraegeCache = vertraege;
        } else if (result?.ErrorMessage) {
            UiHelper.showError(result.ErrorMessage);
        } else {
            UiHelper.showFehlerKommunikation();
        }

        this.items = [];

        for (const vertrag of vertraege) {
            const item: VertragListItem = {
                vertrag: vertrag,
            }

            this.items.push(item);
        }

        log?.debug('ladeVertraege done');

        this.cdr.detectChanges();
    }

    async ngAfterViewInit() {
        log?.debug('ngAfterViewInit');

        // setTimeout(() => {
        //     if (this.searchbar) {
        //         try {
        //             this.searchbar.setFocus();
        //         } catch (err) {
        //             log.error('setTimeout onSuchen: ' + Utils.getErrorMessage(err), err);
        //         }
        //     }

        //     this.cdr.detectChanges();
        // }, 500);

        // this.cdr.detectChanges();
    }

    refresh() {
        log?.debug('refresh');
        this.filterSichtbareItems();
    }

    onClose() {
        log?.debug('onClose');
        this.modalController.dismiss(null);
    }

    async onSearchChanged(e: Event) {
        log?.debug('onSearchChanged', e);

        await this.ladeVertraege(true);
        this.filterSichtbareItems();

        this.cdr.detectChanges();
    }

    private filterSichtbareItems() {
        log?.debug('filterSichtbareItems');

        // let sichtbareItems: VertragListItem[];

        // if (this.suchtext && this.suchtext.trim()) {
        //     sichtbareItems = [];

        //     const parts: string[] = this.suchtext.toLowerCase().trim().split(' ');

        //     for (const item of this.items) {
        //         let isMatch = true;

        //         for (const str of parts) {
        //             if (!item.suchtext.includes(str)) {
        //                 isMatch = false;
        //                 break;
        //             }
        //         }

        //         if (isMatch) {
        //             sichtbareItems.push(item);
        //         }
        //     }
        // } else {
        //     sichtbareItems = this.items;
        // }

        // this.sichtbareItems = sichtbareItems;

        // Die Suche läuft derzeit über den Server
        this.sichtbareItems = this.items;

        this.cdr.detectChanges();
    }

    async onItemSelected(item: VertragListItem) {
        log?.debug('onItemSelected', item);

        this.mitPositionswahl = AppConfig.current.einstellungen.TransportauftragNeuanlageVertragMitPosWahl === "ja";

        const component = this.mitPositionswahl
            ? VertragPositionenComponent
            : VertragDetailsComponent;
            
        const modal = await this.modalController.create({
            component,
            componentProps: {
                vertrag: item.vertrag,
                auftragstyp: this.auftragstyp
            }
        });

        await modal.present();
        const result = await modal.onDidDismiss();

        if (result && result.data) {
            this.modalController.dismiss(result.data);
        }
    }
}
